<template>
  <div>
    <div class="table-responsive" v-if="mode != 'pdf'">
      <div>
        <h4 class="service-response-h4">
          {{ $t("message.contragent_search.enterprise_risk_scan") }}
        </h4>
      </div>
      <div>
        <!--Strings Block-->
        <div class="row">
          <div class="col-4">
            <img :src="results.ImageUrl" :alt="results.ImageUrl" />
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_AreaCode") }}:<br /><strong>{{
              results.AreaCode
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_RecCap") }}:<br /><strong>{{
              results.RecCap
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_EntType") }}:<br /><strong>{{
              results.EntType
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_StockType") }}:<br /><strong>{{
              results.StockType
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{
              $t("message.contragent_search.ers_StockNumber")
            }}:<br /><strong>{{ results.StockNumber }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_IsOnStock") }}:<br /><strong>{{
              results.IsOnStock
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_OrgNo") }}:<br /><strong>{{
              results.OrgNo
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_CheckDate") }}:<br /><strong>{{
              results.CheckDate
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_TeamEnd") }}:<br /><strong>{{
              results.TeamEnd
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_TermStart") }}:<br /><strong>{{
              results.TermStart
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_Scope") }}:<br /><strong>{{
              results.Scope
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_Address") }}:<br /><strong>{{
              results.Address
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_EconKind") }}:<br /><strong>{{
              results.EconKind
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{
              $t("message.contragent_search.ers_RegistCapi")
            }}:<br /><strong>{{ results.RegistCapi }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{
              $t("message.contragent_search.ers_CreditCode")
            }}:<br /><strong>{{ results.CreditCode }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{
              $t("message.contragent_search.ers_UpdatedDate")
            }}:<br /><strong>{{ results.UpdatedDate }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_Province") }}:<br /><strong>{{
              results.Province
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_Status") }}:<br /><strong>{{
              results.Status
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_EndDate") }}:<br /><strong>{{
              results.EndDate
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_StartDate") }}:<br /><strong>{{
              results.StartDate
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_OperName") }}:<br /><strong>{{
              results.OperName
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_BelongOrg") }}:<br /><strong>{{
              results.BelongOrg
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_No") }}:<br /><strong>{{
              results.No
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_Name") }}:<br /><strong>{{
              results.Name
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_IXCode") }}:<br /><strong>{{
              results.IXCode
            }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{
              $t("message.contragent_search.ers_PersonScope")
            }}:<br /><strong>{{ results.PersonScope }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{
              $t("message.contragent_search.ers_EnglishName")
            }}:<br /><strong>{{ results.EnglishName }}</strong>
          </div>
          <div class="col-4 mb-2">
            {{
              $t("message.contragent_search.ers_InsuredCount")
            }}:<br /><strong>{{ results.InsuredCount }}</strong>
          </div>

          <div class="col-4 mb-2" v-if="results.Liquidation">
            {{ $t("message.contragent_search.ers_Liquidation") }}:<br /><strong
              >{{ results.Liquidation.Leader }} -
              {{ results.Liquidation.Member }}</strong
            >
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_ContactInfo") }}:<br /><strong
              ><span v-if="results.ContactInfo && results.ContactInfo.WebSite"
                ><a :href="results.ContactInfo.WebSite.Url">{{
                  results.ContactInfo.WebSite.Url
                }}</a
                ><br /></span
              >{{ results.ContactInfo.PhoneNumber }}<br />{{
                results.ContactInfo.Email
              }}</strong
            >
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_Industry") }}:<br />
            <strong
              >{{ $t("message.contragent_search.ers_ind_IndustryCode") }}:
              {{ results.Industry.IndustryCode }}</strong
            ><br />
            <strong
              >{{ $t("message.contragent_search.ers_ind_Industry") }}:
              {{ results.Industry.Industry }}</strong
            ><br />
            <strong
              >{{ $t("message.contragent_search.ers_ind_SubIndustryCode") }}:
              {{ results.Industry.SubIndustryCode }}</strong
            ><br />
            <strong
              >{{ $t("message.contragent_search.ers_ind_SubIndustry") }}:
              {{ results.Industry.SubIndustry }}</strong
            ><br />
            <strong
              >{{ $t("message.contragent_search.ers_ind_MiddleCategoryCode") }}:
              {{ results.Industry.MiddleCategoryCode }}</strong
            ><br />
            <strong
              >{{ $t("message.contragent_search.ers_ind_MiddleCategory") }}:
              {{ results.Industry.MiddleCategory }}</strong
            ><br />
            <strong
              >{{ $t("message.contragent_search.ers_ind_SmallCategoryCode") }}:
              {{ results.Industry.SmallCategoryCode }}</strong
            ><br />
            <strong
              >{{ $t("message.contragent_search.ers_ind_SmallCategory") }}:
              {{ results.Industry.SmallCategory }}</strong
            ><br />
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_Area") }}:<br />
            <strong
              >{{ $t("message.contragent_search.ers_area_Province") }}:
              {{ results.Area.Province }}</strong
            ><br />
            <strong
              >{{ $t("message.contragent_search.ers_area_City") }}:
              {{ results.Area.City }}</strong
            ><br />
            <strong
              >{{ $t("message.contragent_search.ers_area_County") }}:
              {{ results.Area.County }}</strong
            ><br />
          </div>
          <div class="col-4 mb-2">
            {{ $t("message.contragent_search.ers_RevokeInfo") }}:<br />
            <strong
              >{{ $t("message.contragent_search.ers_rev_CancelDate") }}:
              {{ results.RevokeInfo.CancelDate }}</strong
            ><br />
            <strong
              >{{ $t("message.contragent_search.ers_rev_CancelReason") }}:
              {{ results.RevokeInfo.CancelReason }}</strong
            ><br />
            <strong
              >{{ $t("message.contragent_search.ers_rev_RevokeDate") }}:
              {{ results.RevokeInfo.RevokeDate }}</strong
            ><br />
            <strong
              >{{ $t("message.contragent_search.ers_rev_RevokeReason") }}:
              {{ results.RevokeInfo.RevokeReason }}</strong
            ><br />
          </div>
        </div>
      </div>

      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_PermissionInfo") }}
      </h5>
      <div>
        <div class="table-responsive">
          <b-table
            :fields="PermissionInfo_fields"
            :items="results.PermissionInfo"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_Penalty") }}
      </h5>
      <div>
        <div class="table-responsive">
          <b-table :fields="Penalty_fields" :items="results.Penalty"></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_Exceptions") }}
      </h5>
      <div>
        <div class="table-responsive">
          <b-table
            :fields="Exceptions_fields"
            :items="results.Exceptions"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_ShiXinItems") }}
      </h5>
      <div>
        <div class="table-responsive">
          <b-table
            :fields="ShiXinItems_fields"
            :items="results.ShiXinItems"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_ZhiXingItems") }}
      </h5>
      <div>
        <div class="table-responsive">
          <b-table
            :fields="ZhiXingItems_fields"
            :items="results.ZhiXingItems"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_MPledge") }}
      </h5>
      <div>
        <div>
          <b-table :fields="MPledge_fields" :items="results.MPledge"></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_Pledge") }}
      </h5>
      <div>
        <div class="table-responsive">
          <b-table :fields="Pledge_fields" :items="results.Pledge"></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_SpotCheck") }}
      </h5>
      <div>
        <div class="table-responsive">
          <b-table
            :fields="SpotCheck_fields"
            :items="results.SpotCheck"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_CompanyTaxCreditItems") }}
      </h5>
      <div>
        <div class="table-responsive">
          <b-table
            :fields="CompanyTaxCreditItems_fields"
            :items="results.CompanyTaxCreditItems"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_CompanyProducts") }}
      </h5>
      <div>
        <div class="table-responsive">
          <b-table
            :fields="CompanyProducts_fields"
            :items="results.CompanyProducts"
          >
            <template v-slot:cell(ImageUrl)="data">
              <img :src="data.value" :alt="data.value" />
            </template>
          </b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_PermissionEciInfo") }}
      </h5>
      <div>
        <div class="table-responsive">
          <b-table
            :fields="PermissionEciInfo_fields"
            :items="results.PermissionEciInfo"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_PenaltyCreditChina") }}
      </h5>
      <div>
        <div class="table-responsive">
          <b-table
            :fields="PenaltyCreditChina_fields"
            :items="results.PenaltyCreditChina"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_Partners") }}
      </h5>
      <div>
        <div>
          <b-table
            :fixed="true"
            :fields="Partners_fields"
            :items="results.Partners"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_Employees") }}
      </h5>
      <div>
        <div class="table-responsive">
          <b-table
            :fields="Employees_fields"
            :items="results.Employees"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_Branches") }}
      </h5>
      <div>
        <div class="table-responsive">
          <b-table
            :fields="Branches_fields"
            :items="results.Branches"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_ChangeRecords") }}
      </h5>
      <div>
        <div class="table-responsive">
          <b-table
            :fields="ChangeRecords_fields"
            :items="results.ChangeRecords"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_EmergingIndustyList") }}
      </h5>
      <div>
        <div class="table-responsive">
          <b-table
            :fields="EmergingIndustyList_fields"
            :items="results.EmergingIndustyList"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_TagList") }}
      </h5>
      <div>
        <div class="table-responsive">
          <b-table :fields="TagList_fields" :items="results.TagList"></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_ARContactList") }}
      </h5>
      <div>
        <div class="table-responsive">
          <b-table
            :fields="ARContactList_fields"
            :items="results.ARContactList"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_OriginalName") }}
      </h5>
      <div>
        <div class="table-responsive">
          <b-table
            :fields="OriginalName_fields"
            :items="results.OriginalName"
          ></b-table>
        </div>
      </div>
    </div>
    <div class="" v-if="mode == 'pdf'">
      <br />
      <h2 class="service-response-h4">
        {{ $t("message.contragent_search.enterprise_risk_scan") }}
      </h2>
      <div>
        <div class="row">
          <div class="col-4">
            <img :src="results.ImageUrl" :alt="results.ImageUrl" />
          </div>
          <table style="width: 100%">
            <tr>
              <td>{{ $t("message.contragent_search.ers_AreaCode") }}:</td>
              <td>
                <strong>{{ results.AreaCode }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_RecCap") }}:</td>
              <td>
                <strong>{{ results.RecCap }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_EntType") }}:</td>
              <td>
                <strong>{{ results.EntType }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_StockType") }}:</td>
              <td>
                <strong>{{ results.StockType }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_StockNumber") }}:</td>
              <td>
                <strong>{{ results.StockNumber }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_IsOnStock") }}:</td>
              <td>
                <strong>{{ results.IsOnStock }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_OrgNo") }}:</td>
              <td>
                <strong>{{ results.OrgNo }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_CheckDate") }}:</td>
              <td>
                <strong>{{ results.CheckDate }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_TeamEnd") }}:</td>
              <td>
                <strong>{{ results.TeamEnd }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_TermStart") }}:</td>
              <td>
                <strong>{{ results.TermStart }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_Scope") }}:</td>
              <td>
                <strong>{{ results.Scope }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_Address") }}:</td>
              <td>
                <strong>{{ results.Address }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_EconKind") }}:</td>
              <td>
                <strong>{{ results.EconKind }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_RegistCapi") }}:</td>
              <td>
                <strong>{{ results.RegistCapi }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_CreditCode") }}:</td>
              <td>
                <strong>{{ results.CreditCode }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_UpdatedDate") }}:</td>
              <td>
                <strong>{{ results.UpdatedDate }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_Province") }}:</td>
              <td>
                <strong>{{ results.Province }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_Status") }}:</td>
              <td>
                <strong>{{ results.Status }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_EndDate") }}:</td>
              <td>
                <strong>{{ results.EndDate }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_StartDate") }}:</td>
              <td>
                <strong>{{ results.StartDate }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_OperName") }}:</td>
              <td>
                <strong>{{ results.OperName }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_BelongOrg") }}:</td>
              <td>
                <strong>{{ results.BelongOrg }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_No") }}:</td>
              <td>
                <strong>{{ results.No }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_Name") }}:</td>
              <td>
                <strong>{{ results.Name }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_IXCode") }}:</td>
              <td>
                <strong>{{ results.IXCode }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_PersonScope") }}:</td>
              <td>
                <strong>{{ results.PersonScope }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_EnglishName") }}:</td>
              <td>
                <strong>{{ results.EnglishName }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_InsuredCount") }}:</td>
              <td>
                <strong>{{ results.InsuredCount }}</strong>
              </td>
            </tr>

            <tr v-if="results.Liquidation">
              <td>{{ $t("message.contragent_search.ers_Liquidation") }}:</td>
              <td>
                <strong
                  >{{ results.Liquidation.Leader }} -
                  {{ results.Liquidation.Member }}</strong
                >
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_ContactInfo") }}:</td>
              <td>
                <strong
                  ><span v-if="results.ContactInfo.WebSite"
                    ><a :href="results.ContactInfo.WebSite.Url">{{
                      results.ContactInfo.WebSite.Url
                    }}</a
                    ><br /></span
                  >{{ results.ContactInfo.PhoneNumber }}<br />{{
                    results.ContactInfo.Email
                  }}</strong
                >
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_Industry") }}:</td>
              <td>
                <strong
                  >{{ $t("message.contragent_search.ers_ind_IndustryCode") }}:
                  {{ results.Industry.IndustryCode }}</strong
                ><br />
                <strong
                  >{{ $t("message.contragent_search.ers_ind_Industry") }}:
                  {{ results.Industry.Industry }}</strong
                ><br />
                <strong
                  >{{
                    $t("message.contragent_search.ers_ind_SubIndustryCode")
                  }}: {{ results.Industry.SubIndustryCode }}</strong
                ><br />
                <strong
                  >{{ $t("message.contragent_search.ers_ind_SubIndustry") }}:
                  {{ results.Industry.SubIndustry }}</strong
                ><br />
                <strong
                  >{{
                    $t("message.contragent_search.ers_ind_MiddleCategoryCode")
                  }}: {{ results.Industry.MiddleCategoryCode }}</strong
                ><br />
                <strong
                  >{{ $t("message.contragent_search.ers_ind_MiddleCategory") }}:
                  {{ results.Industry.MiddleCategory }}</strong
                ><br />
                <strong
                  >{{
                    $t("message.contragent_search.ers_ind_SmallCategoryCode")
                  }}: {{ results.Industry.SmallCategoryCode }}</strong
                ><br />
                <strong
                  >{{ $t("message.contragent_search.ers_ind_SmallCategory") }}:
                  {{ results.Industry.SmallCategory }}</strong
                ><br />
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_Area") }}:</td>
              <td>
                <strong
                  >{{ $t("message.contragent_search.ers_area_Province") }}:
                  {{ results.Area.Province }}</strong
                ><br />
                <strong
                  >{{ $t("message.contragent_search.ers_area_City") }}:
                  {{ results.Area.City }}</strong
                ><br />
                <strong
                  >{{ $t("message.contragent_search.ers_area_County") }}:
                  {{ results.Area.County }}</strong
                ><br />
              </td>
            </tr>
            <tr>
              <td>{{ $t("message.contragent_search.ers_RevokeInfo") }}:</td>
              <td>
                <strong
                  >{{ $t("message.contragent_search.ers_rev_CancelDate") }}:
                  {{ results.RevokeInfo.CancelDate }}</strong
                ><br />
                <strong
                  >{{ $t("message.contragent_search.ers_rev_CancelReason") }}:
                  {{ results.RevokeInfo.CancelReason }}</strong
                ><br />
                <strong
                  >{{ $t("message.contragent_search.ers_rev_RevokeDate") }}:
                  {{ results.RevokeInfo.RevokeDate }}</strong
                ><br />
                <strong
                  >{{ $t("message.contragent_search.ers_rev_RevokeReason") }}:
                  {{ results.RevokeInfo.RevokeReason }}</strong
                ><br />
              </td>
            </tr>
          </table>
        </div>
      </div>

      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_PermissionInfo") }}
      </h5>
      <div>
        <b-table
          :fields="PermissionInfo_fields"
          :items="results.PermissionInfo"
        ></b-table>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_Penalty") }}
      </h5>
      <div>
        <div class="">
          <b-table :fields="Penalty_fields" :items="results.Penalty"></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_Exceptions") }}
      </h5>
      <h6>
                {{ $t("message.contragent_search.ers_Exceptions_description") }}
      </h6>
      <div>
        <div class="">
          <b-table
            :fields="Exceptions_fields"
            :items="results.Exceptions"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_ShiXinItems") }}
      </h5>
      <div>
        <div class="">
          <b-table
            :fields="ShiXinItems_fields"
            :items="results.ShiXinItems"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_ZhiXingItems") }}
      </h5>
      <div>
        <div class="">
          <b-table
            :fields="ZhiXingItems_fields"
            :items="results.ZhiXingItems"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_MPledge") }}
      </h5>
      <div>
        <div>
          <b-table :fields="MPledge_fields" :items="results.MPledge"></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_Pledge") }}
      </h5>
      <div>
        <div class="">
          <b-table
            :fields="Pledge_fields_pdf[0]"
            :items="results.Pledge"
          ></b-table>
          <br />
          <b-table
            :fields="Pledge_fields_pdf[1]"
            :items="results.Pledge"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_SpotCheck") }}
      </h5>
      <div>
        <div class="">
          <b-table
            :fields="SpotCheck_fields"
            :items="results.SpotCheck"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_CompanyTaxCreditItems") }}
      </h5>
      <div>
        <div class="">
          <b-table
            :fields="CompanyTaxCreditItems_fields"
            :items="results.CompanyTaxCreditItems"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_CompanyProducts") }}
      </h5>
      <div>
        <div class="">
          <b-table
            :fields="CompanyProducts_fields"
            :items="results.CompanyProducts"
          >
            <template v-slot:cell(ImageUrl)="data">
              <img
                :src="data.value"
                :alt="data.value"
                style="max-width: 50px"
              />
            </template>
          </b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_PermissionEciInfo") }}
      </h5>
      <div>
        <div class="">
          <b-table
            :fixed="true"
            :fields="PermissionEciInfo_fields"
            :items="results.PermissionEciInfo"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_PenaltyCreditChina") }}
      </h5>
      <div>
        <div class="">
          <b-table
            :fixed="true"
            :fields="PenaltyCreditChina_fields"
            :items="results.PenaltyCreditChina"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_Partners") }}
      </h5>
      <div>
        <div>
          <b-table
            :fixed="true"
            :fields="Partners_fields_pdf[0]"
            :items="results.Partners"
          ></b-table>
          <br />
          <b-table
            :fixed="true"
            :fields="Partners_fields_pdf[1]"
            :items="results.Partners"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_Employees") }}
      </h5>
      <div>
        <div class="">
          <b-table
            :fixed="true"
            :fields="Employees_fields"
            :items="results.Employees"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_Branches") }}
      </h5>
      <div>
        <div class="">
          <b-table
            :fixed="true"
            :fields="Branches_fields"
            :items="results.Branches"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_ChangeRecords") }}
      </h5>
      <div>
        <div class="">
          <b-table
            :fixed="true"
            :fields="ChangeRecords_fields"
            :items="results.ChangeRecords"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_EmergingIndustyList") }}
      </h5>
      <div>
        <div class="">
          <b-table
            :fixed="true"
            :fields="EmergingIndustyList_fields"
            :items="results.EmergingIndusty"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_TagList") }}
      </h5>
      <div>
        <div class="">
          <b-table
            :fixed="true"
            :fields="TagList_fields"
            :items="results.TagList"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_ARContactList") }}
      </h5>
      <div>
        <div class="">
          <b-table
            :fixed="true"
            :fields="ARContactList_fields"
            :items="results.ARContactList"
          ></b-table>
        </div>
      </div>
      <h5 class="service-response-h4">
        {{ $t("message.contragent_search.ers_OriginalName") }}
      </h5>
      <div>
        <div class="">
          <b-table
            :fixed="true"
            :fields="OriginalName_fields"
            :items="results.OriginalName"
          ></b-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data", "mode"],
  data() {
    return {
      results: {
        Industry: {},
        Area: {},
        RevokeInfo: {},
        Penalty: [],
        Exceptions: [],
        ShiXinItems: [],
        ZhiXingItems: [],
        MPledge: [],
        Pledge: [],
        SpotCheck: [],
        CompanyTaxCreditItems: [],
        CompanyProducts: [],
        PermissionEciInfo: [],
        PenaltyCreditChina: [],
        Partners: [],
        Employees: [],
        Branches: [],
        ChangeRecords: [],
        EmergingIndustyList: [],
        TagList: [],
        ARContactList: [],
        OriginalName: [],
        ContactInfo: {},
      },

      PermissionInfo_fields: [
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "Province",
          label: this.$t("message.contragent_search.ers_pi_Province"),
        },
        {
          key: "Liandate",
          label: this.$t("message.contragent_search.ers_pi_Liandate"),
        },
        {
          key: "CaseNo",
          label: this.$t("message.contragent_search.ers_pi_CaseNo"),
        },
      ],
      Penalty_fields: [
        {
          key: "DocNo",
          label: this.$t("message.contragent_search.ers_pi_DocNo"),
        },
        {
          key: "PenaltyType",
          label: this.$t("message.contragent_search.ers_pi_PenaltyType"),
        },
        {
          key: "OfficeName",
          label: this.$t("message.contragent_search.ers_pi_OfficeName"),
        },
        {
          key: "Content",
          label: this.$t("message.contragent_search.ers_pi_Content"),
        },
        {
          key: "PenaltyDate",
          label: this.$t("message.contragent_search.ers_pi_PenaltyDate"),
        },
        {
          key: "PublicDate",
          label: this.$t("message.contragent_search.ers_pi_PublicDate"),
        },
        {
          key: "Remark",
          label: this.$t("message.contragent_search.ers_pi_Remark"),
        },
      ],
      Exceptions_fields: [
        {
          key: "AddReason",
          label: this.$t("message.contragent_search.ers_pi_AddReason"),
        },
        {
          key: "AddDate",
          label: this.$t("message.contragent_search.ers_pi_AddDate"),
        },
        {
          key: "RomoveReason",
          label: this.$t("message.contragent_search.ers_pi_RomoveReason"),
        },
        {
          key: "RemoveDate",
          label: this.$t("message.contragent_search.ers_pi_RemoveDate"),
        },
        {
          key: "DecisionOffice",
          label: this.$t("message.contragent_search.ers_pi_DecisionOffice"),
        },
        {
          key: "RemoveDecisionOffice",
          label: this.$t(
            "message.contragent_search.ers_pi_RemoveDecisionOffice",
          ),
        },
      ],
      ShiXinItems_fields: [
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "Liandate",
          label: this.$t("message.contragent_search.ers_pi_Liandate"),
        },
        {
          key: "Anno",
          label: this.$t("message.contragent_search.ers_pi_Anno"),
        },
        {
          key: "Orgno",
          label: this.$t("message.contragent_search.ers_pi_Orgno"),
        },
        {
          key: "Execute",
          label: this.$t("message.contragent_search.ers_pi_Execute"),
        },
        {
          key: "Publicdate",
          label: this.$t("message.contragent_search.ers_pi_Publicdate"),
        },
        {
          key: "Executestatus",
          label: this.$t("message.contragent_search.ers_pi_Executestatus"),
        },
        {
          key: "Actionremark",
          label: this.$t("message.contragent_search.ers_pi_Actionremark"),
        },
        {
          key: "Executegov",
          label: this.$t("message.contragent_search.ers_pi_Executegov"),
        },
      ],
      ZhiXingItems_fields: [
        { key: "Id", label: this.$t("message.contragent_search.ers_pi_Id") },
        {
          key: "Sourceid",
          label: this.$t("message.contragent_search.ers_pi_Sourceid"),
        },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "Liandate",
          label: this.$t("message.contragent_search.ers_pi_Liandate"),
        },
        {
          key: "Anno",
          label: this.$t("message.contragent_search.ers_pi_Anno"),
        },
        {
          key: "ExecuteGov",
          label: this.$t("message.contragent_search.ers_pi_ExecuteGov"),
        },
        {
          key: "Biaodi",
          label: this.$t("message.contragent_search.ers_pi_Biaodi"),
        },
        {
          key: "Status",
          label: this.$t("message.contragent_search.ers_pi_Status"),
        },
        {
          key: "PartyCardNum",
          label: this.$t("message.contragent_search.ers_pi_PartyCardNum"),
        },
        {
          key: "Updatedate",
          label: this.$t("message.contragent_search.ers_pi_Updatedate"),
        },
      ],
      MPledge_fields: [
        {
          key: "RegisterNo",
          label: this.$t("message.contragent_search.ers_pi_RegisterNo"),
        },
        {
          key: "RegisterDate",
          label: this.$t("message.contragent_search.ers_pi_RegisterDate"),
        },
        {
          key: "PublicDate",
          label: this.$t("message.contragent_search.ers_pi_PublicDate"),
        },
        {
          key: "RegisterOffice",
          label: this.$t("message.contragent_search.ers_pi_RegisterOffice"),
        },
        {
          key: "DebtSecuredAmount",
          label: this.$t("message.contragent_search.ers_pi_DebtSecuredAmount"),
        },
        {
          key: "Status",
          label: this.$t("message.contragent_search.ers_pi_Status"),
        },
      ],
      Pledge_fields: [
        {
          key: "CompanyId",
          label: this.$t("message.contragent_search.ers_pi_CompanyId"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "RegistNo",
          label: this.$t("message.contragent_search.ers_pi_RegistNo"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "Pledgor",
          label: this.$t("message.contragent_search.ers_pi_Pledgor"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "PledgorNo",
          label: this.$t("message.contragent_search.ers_pi_PledgorNo"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "Pledge",
          label: this.$t("message.contragent_search.ers_pi_Pledge"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "PledgeNo",
          label: this.$t("message.contragent_search.ers_pi_PledgeNo"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "PledgedAmount",
          label: this.$t("message.contragent_search.ers_pi_PledgedAmount"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "RegDate",
          label: this.$t("message.contragent_search.ers_pi_RegDate"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "PublicDate",
          label: this.$t("message.contragent_search.ers_pi_PublicDate"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "Status",
          label: this.$t("message.contragent_search.ers_pi_Status"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
      ],
      Pledge_fields_pdf: [
        [
          {
            key: "CompanyId",
            label: this.$t("message.contragent_search.ers_pi_CompanyId"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "RegistNo",
            label: this.$t("message.contragent_search.ers_pi_RegistNo"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "Pledgor",
            label: this.$t("message.contragent_search.ers_pi_Pledgor"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "PledgorNo",
            label: this.$t("message.contragent_search.ers_pi_PledgorNo"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "Pledge",
            label: this.$t("message.contragent_search.ers_pi_Pledge"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
        ],
        [
          {
            key: "PledgeNo",
            label: this.$t("message.contragent_search.ers_pi_PledgeNo"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "PledgedAmount",
            label: this.$t("message.contragent_search.ers_pi_PledgedAmount"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "RegDate",
            label: this.$t("message.contragent_search.ers_pi_RegDate"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "PublicDate",
            label: this.$t("message.contragent_search.ers_pi_PublicDate"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "Status",
            label: this.$t("message.contragent_search.ers_pi_Status"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
        ],
      ],
      SpotCheck_fields: [
        { key: "No", label: this.$t("message.contragent_search.ers_pi_No") },
        {
          key: "ExecutiveOrg",
          label: this.$t("message.contragent_search.ers_pi_ExecutiveOrg"),
        },
        {
          key: "Type",
          label: this.$t("message.contragent_search.ers_pi_Type"),
        },
        {
          key: "Date",
          label: this.$t("message.contragent_search.ers_pi_Date"),
        },
        {
          key: "Consequence",
          label: this.$t("message.contragent_search.ers_pi_Consequence"),
        },
        {
          key: "Remark",
          label: this.$t("message.contragent_search.ers_pi_Remark"),
        },
      ],
      CompanyTaxCreditItems_fields: [
        { key: "No", label: this.$t("message.contragent_search.ers_pi_No") },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "Year",
          label: this.$t("message.contragent_search.ers_pi_Year"),
        },
        {
          key: "Level",
          label: this.$t("message.contragent_search.ers_pi_Level"),
        },
      ],
      CompanyProducts_fields: [
        {
          key: "CompanyName",
          label: this.$t("message.contragent_search.ers_pi_CompanyName"),
        },
        {
          key: "Link",
          label: this.$t("message.contragent_search.ers_pi_Link"),
        },
        {
          key: "ImageUrl",
          label: this.$t("message.contragent_search.ers_pi_ImageUrl"),
        },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "Domain",
          label: this.$t("message.contragent_search.ers_pi_Domain"),
        },
        {
          key: "Tags",
          label: this.$t("message.contragent_search.ers_pi_Tags"),
        },
        {
          key: "Description",
          label: this.$t("message.contragent_search.ers_pi_Description"),
        },
        {
          key: "Category",
          label: this.$t("message.contragent_search.ers_pi_Category"),
        },
      ],
      PermissionEciInfo_fields: [
        {
          key: "LicensDocNo",
          label: this.$t("message.contragent_search.ers_pi_LicensesDocNo"),
        },
        {
          key: "LicensDocName",
          label: this.$t("message.contragent_search.ers_pi_LicensesDocName"),
        },
        {
          key: "ValidityFrom",
          label: this.$t("message.contragent_search.ers_pi_ValidityFrom"),
        },
        {
          key: "ValidityTo",
          label: this.$t("message.contragent_search.ers_pi_ValidityTo"),
        },
        {
          key: "LicensOffice",
          label: this.$t("message.contragent_search.ers_pi_LicensOffice"),
        },
        {
          key: "LicensContent",
          label: this.$t("message.contragent_search.ers_pi_LicensesContent"),
        },
      ],
      PenaltyCreditChina_fields: [
        {
          key: "CaseNo",
          label: this.$t("message.contragent_search.ers_pi_CaseNo"),
        },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "Liandate",
          label: this.$t("message.contragent_search.ers_pi_Liandate"),
        },
        {
          key: "Province",
          label: this.$t("message.contragent_search.ers_pi_Province"),
        },
        {
          key: "OwnerName",
          label: this.$t("message.contragent_search.ers_pi_OwnerName"),
        },
        {
          key: "CaseReason",
          label: this.$t("message.contragent_search.ers_pi_CaseReason"),
        },
      ],
      Partners_fields: [
        {
          key: "StockName",
          label: this.$t("message.contragent_search.ers_pi_StockName"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "StockType",
          label: this.$t("message.contragent_search.ers_pi_StockType"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "StockPercent",
          label: this.$t("message.contragent_search.ers_pi_StockPercent"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "ShouldCapi",
          label: this.$t("message.contragent_search.ers_pi_ShouldCapi"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "ShouldDate",
          label: this.$t("message.contragent_search.ers_pi_ShouldDate"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "InvestType",
          label: this.$t("message.contragent_search.ers_pi_InvestType"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "InvestName",
          label: this.$t("message.contragent_search.ers_pi_InvestName"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "RealCapi",
          label: this.$t("message.contragent_search.ers_pi_RealCapi"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "CapiDate",
          label: this.$t("message.contragent_search.ers_pi_CapiDate"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "TagsList",
          label: this.$t("message.contragent_search.ers_pi_TagsList"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "FinalBenefitPercent",
          label: this.$t(
            "message.contragent_search.ers_pi_FinalBenefitPercent",
          ),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "RelatedProduct",
          label: this.$t("message.contragent_search.ers_pi_RelatedProduct"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "RelatedOrg",
          label: this.$t("message.contragent_search.ers_pi_RelatedOrg"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
      ],
      Partners_fields_pdf: [
        [
          {
            key: "StockName",
            label: this.$t("message.contragent_search.ers_pi_StockName"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "StockType",
            label: this.$t("message.contragent_search.ers_pi_StockType"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "StockPercent",
            label: this.$t("message.contragent_search.ers_pi_StockPercent"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "ShouldCapi",
            label: this.$t("message.contragent_search.ers_pi_ShouldCapi"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "ShouldDate",
            label: this.$t("message.contragent_search.ers_pi_ShouldDate"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "InvestType",
            label: this.$t("message.contragent_search.ers_pi_InvestType"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "InvestName",
            label: this.$t("message.contragent_search.ers_pi_InvestName"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
        ],
        [
          {
            key: "RealCapi",
            label: this.$t("message.contragent_search.ers_pi_RealCapi"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "CapiDate",
            label: this.$t("message.contragent_search.ers_pi_CapiDate"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "TagsList",
            label: this.$t("message.contragent_search.ers_pi_TagsList"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "FinalBenefitPercent",
            label: this.$t(
              "message.contragent_search.ers_pi_FinalBenefitPercent",
            ),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "RelatedProduct",
            label: this.$t("message.contragent_search.ers_pi_RelatedProduct"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "RelatedOrg",
            label: this.$t("message.contragent_search.ers_pi_RelatedOrg"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
        ],
      ],
      Employees_fields: [
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        { key: "Job", label: this.$t("message.contragent_search.ers_pi_Job") },
      ],
      Branches_fields: [
        {
          key: "CompanyId",
          label: this.$t("message.contragent_search.ers_pi_CompanyId"),
        },
        {
          key: "RegNo",
          label: this.$t("message.contragent_search.ers_pi_RegNo"),
        },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "BelongOrg",
          label: this.$t("message.contragent_search.ers_pi_BelongOrg"),
        },
        {
          key: "CreditCode",
          label: this.$t("message.contragent_search.ers_pi_CreditCode"),
        },
        {
          key: "OperName",
          label: this.$t("message.contragent_search.ers_pi_OperName"),
        },
      ],
      ChangeRecords_fields: [
        {
          key: "ProjectName",
          label: this.$t("message.contragent_search.ers_pi_ProjectName"),
        },
        {
          key: "BeforeContent",
          label: this.$t("message.contragent_search.ers_pi_BeforeContent"),
        },
        {
          key: "AfterContent",
          label: this.$t("message.contragent_search.ers_pi_AfterContent"),
        },
        {
          key: "ChangeDate",
          label: this.$t("message.contragent_search.ers_pi_ChangeDate"),
        },
      ],
      EmergingIndustyList_fields: [
        {
          key: "IndustryCode",
          label: this.$t("message.contragent_search.ers_pi_IndustryCode"),
        },
        {
          key: "Industry",
          label: this.$t("message.contragent_search.ers_pi_Industry"),
        },
        {
          key: "SubIndustryCode",
          label: this.$t("message.contragent_search.ers_pi_SubIndustryCode"),
        },
        {
          key: "SubIndustry",
          label: this.$t("message.contragent_search.ers_pi_SubIndustry"),
        },
        {
          key: "MiddleCategoryCode",
          label: this.$t("message.contragent_search.ers_pi_MiddleCategoryCode"),
        },
        {
          key: "MiddleCategory",
          label: this.$t("message.contragent_search.ers_pi_MiddleCategory"),
        },
        {
          key: "SmallCategoryCode",
          label: this.$t("message.contragent_search.ers_pi_SmallCategoryCode"),
        },
        {
          key: "SmallCategory",
          label: this.$t("message.contragent_search.ers_pi_SmallCategory"),
        },
      ],
      TagList_fields: [
        {
          key: "Type",
          label: this.$t("message.contragent_search.ers_pi_Type"),
        },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
      ],
      ARContactList_fields: [
        {
          key: "ContactNo",
          label: this.$t("message.contragent_search.ers_pi_ContactNo"),
        },
        {
          key: "EmailAddress",
          label: this.$t("message.contragent_search.ers_pi_EmailAddress"),
        },
        {
          key: "Address",
          label: this.$t("message.contragent_search.ers_pi_Address"),
        },
      ],
      OriginalName_fields: [
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "ChangeDate",
          label: this.$t("message.contragent_search.ers_pi_ChangeDate"),
        },
      ],
    };
  },
  mounted() {
    this.results = this.data;
    console.log("results736", this.results);
  },
  methods: {},
  watch: {
    data: function (newVal, oldVal) {
      this.results = newVal;
    },
  },
};
</script>
<style>
.row-grid {
  font-size: 10px;
  padding: 4px !important;
}
</style>
